// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_isS","cls2":"VideoResults-cls2_cIS VideoResults-cls1_isS"};